(function (aqurate) {
	// Public properties
	aqurate.baseUrl = 'https://api.aqurate.ai/v1';

	// Public methods
	aqurate.getItemsForRecommendationType = function (id, token, type, productsToShow) {
		let uniqueUrl;

		switch (type) {
			case 'aqr_crossSellProductList':
				uniqueUrl = '/recs/item/cross-sell';
				break;
			case 'aqr_similarProductList':
				uniqueUrl = '/recs/item/similar';
				break;
			case 'aqr_substituteProductList':
				uniqueUrl = '/recs/item/substitutes';
				break;
			case 'aqr_bestSellerItemList':
				uniqueUrl = '/recs/item/bestseller-in-same-category';
				break;
			case 'aqr_upSellItemList':
				uniqueUrl = '/recs/item/up-sell';
				break;
			default:
				break;
		}

		const URL = `${aqurate.baseUrl}${uniqueUrl}?product_id=${id}&top=${productsToShow}`;
		const REQUEST = {
			method: 'GET',
			headers: {
				'X-Auth-Token': token,
				'Content-Type': 'application/json',
			},
		};
		return fetch(URL, REQUEST)
			.then((res) => res.json())
			.then((data) => {
				return data;
			})
			.catch((error) => {
				console.log(error);
			});
	};

	aqurate.getTokenURL = function (apiToken) {
		if (!aqurate.baseUrl) {
			console.error('aqurate.baseUrl is not defined');
			return;
		}
	
		const URL = aqurate.baseUrl + '/shopify-storefront-token';
		const REQUEST = {
			method: 'GET',
			headers: {
				'X-Auth-Token': apiToken,
				'Content-Type': 'application/json'
			},
		};
	
		return fetch(URL, REQUEST)
			.then((res) => {
				if (!res.ok) {
					throw new Error('Network response was not ok: ' + res.statusText);
				}
				return res.json();
			})
			.then((data) => {
				if (data && data.token) {
					return data.token;
				} else {
					throw new Error('Token not found in response');
				}
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	};

	aqurate.getProduct = function (id, token, origin) {
		const query = `query {
			product(id: "gid://shopify/Product/${id}") {
			id
			title
			onlineStoreUrl
			vendor
			productPrp: metafield(namespace: "custom", key: "product_prp"){
				value
			}
			variants(first: 2) {
				edges {
					node {
						id
						availableForSale
						compareAtPrice {
							amount
							currencyCode
						}
						price {
							amount
							currencyCode
						}
						image {
							url
						}
					}
				}
			}
			}
		}`;
		const URL = origin + '/api/2023-01/graphql.json';
		const REQUEST = {
			method: 'POST',
			headers: {
				'X-Shopify-Storefront-Access-Token': token,
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ query }),
		};
		return fetch(URL, REQUEST)
			.then((res) => res.json())
			.then((data) => {
				return data;
			})
			.catch((error) => {
				console.log(error);
			});
	};
})((window.aqurate = window.aqurate || {}));